module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon24.a5c6f296.png";